import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-gst-settings',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './gst-settings.component.html',
  styleUrl: './gst-settings.component.css'
})
export class GstSettingsComponent {
  settingsOptions = [
    {
      title: 'Customize Invoice',
      description: 'Personalize your GST layout, update branding, colors, and terms & conditions.',
      icon: 'fas fa-file-invoice-dollar', // FontAwesome Class
      link: '/gst-settings/gst-inv-layout-settings',
      color: 'bg-sky-50',
      iconColor: 'text-sky-400', // Skyblue
      buttonClass: 'bg-sky-500 hover:bg-sky-600'
    },
    {
      title: 'Link WhatsApp',
      description: 'Link your WhatsApp account to send professional PDF invoices directly to customers.',
      icon: 'fab fa-whatsapp', // FontAwesome Class
      link: '/gst-settings/whatsapp-instance',
      color: 'bg-green-50',
      iconColor: 'text-green-600', // Green
      buttonClass: 'bg-green-600 hover:bg-green-700'
    }
  ];
}